import { __assign, __read, __rest, __spreadArray, __values } from "tslib";
import { ActionEntityType, ActionManagerEventEmitter, ActionManagerEventType, } from '@office-start/action-types';
import { createDocumentActions } from '@office-start/document-actions-service';
import { ActionContextMenuItemIcon } from '@office-start/document-types';
import { getOfficeAction } from './actionCreators/officeActionCreator';
import { registerHubActions } from './registration/registerHubActions';
export var createActionManager = function () {
    // Fire events when actions are updated 🔥
    var actionEvents = new ActionManagerEventEmitter();
    // Keep track of all action metadata
    var actionMap = new Map();
    var getMapKey = function (appId, actionId) {
        return "".concat(appId, "_").concat(actionId);
    };
    /**
     *
     * @param action action to be added to this action manager
     * @returns void
     *
     */
    var addAction = function (action) {
        var mapKey = getMapKey(action.metadata.appId, action.metadata.id);
        // Right now, we don't know when a particular application definition changed vs. all of them
        // so we'll have to overwrite all of the actions assuming they all could have changed
        actionMap.set(mapKey, action);
    };
    var getActionById = function (appId, id) {
        return actionMap.get(getMapKey(appId, id));
    };
    /**
     * Translate/register IActionDefinition to OfficeResolvedActionDefinition.
     * @param actions Received actions from a service
     */
    var registerActions = function (actions) {
        var e_1, _a;
        var _loop_1 = function (actionDefinition) {
            //eslint-disable-next-line @typescript-eslint/no-unused-vars
            var executionInfo = actionDefinition.executionInfo, metadata = actionDefinition.metadata, rest = __rest(actionDefinition, ["executionInfo", "metadata"]);
            var resolved = __assign(__assign({}, rest), { metadata: __assign(__assign({}, metadata), { icon: metadata.imageSrc
                        ? {
                            type: ActionContextMenuItemIcon.Url,
                            iconUrl: metadata.imageSrc,
                        }
                        : undefined }), officeActionCreator: function (content) {
                    return getOfficeAction(content, actionDefinition);
                } });
            addAction(resolved);
        };
        try {
            for (var actions_1 = __values(actions), actions_1_1 = actions_1.next(); !actions_1_1.done; actions_1_1 = actions_1.next()) {
                var actionDefinition = actions_1_1.value;
                _loop_1(actionDefinition);
            }
        }
        catch (e_1_1) { e_1 = { error: e_1_1 }; }
        finally {
            try {
                if (actions_1_1 && !actions_1_1.done && (_a = actions_1.return)) _a.call(actions_1);
            }
            finally { if (e_1) throw e_1.error; }
        }
        actionEvents.emit(ActionManagerEventType.ActionsUpdated);
    };
    /**
     * Register actions directly using IAppAction in code
     * @param actions action metadata
     */
    var registerResolvedActions = function (actions) {
        var e_2, _a;
        try {
            for (var actions_2 = __values(actions), actions_2_1 = actions_2.next(); !actions_2_1.done; actions_2_1 = actions_2.next()) {
                var actionDefinition = actions_2_1.value;
                addAction(actionDefinition);
            }
        }
        catch (e_2_1) { e_2 = { error: e_2_1 }; }
        finally {
            try {
                if (actions_2_1 && !actions_2_1.done && (_a = actions_2.return)) _a.call(actions_2);
            }
            finally { if (e_2) throw e_2.error; }
        }
        actionEvents.emit(ActionManagerEventType.ActionsUpdated);
    };
    return Object.assign(actionEvents, {
        getActionByAppId: function (appId, id) {
            return getActionById(appId, id);
        },
        /**
         * @returns actions that are supported on content
         *
         * @todo Use iterable helpers to do the filtering on the iterable iterator instead of converting to array
         */
        getContentActionsMetadata: function () {
            return __spreadArray([], __read(actionMap.values()), false).filter(function (value) {
                return value.entities.some(function (value) { return value.type === ActionEntityType.Content; });
            });
        },
        createDefaultDocumentActions: function (documentActionsParameters) {
            return createDocumentActions(documentActionsParameters.document, documentActionsParameters.index, documentActionsParameters.targetElementId, documentActionsParameters.menuResources, documentActionsParameters.componentContext, documentActionsParameters.identity, documentActionsParameters.isDarkMode);
        },
        registerActions: registerActions,
        registerResolvedActions: registerResolvedActions,
    });
};
export var getInMemoryActionManager = (function () {
    var inMemoryActionManager;
    return function (actionsInContextDialogResources, documentActionsMenuResources, documentActionsToastResources, systemUserConfig) {
        if (inMemoryActionManager === undefined) {
            inMemoryActionManager = createActionManager();
            registerHubActions(inMemoryActionManager, systemUserConfig, {
                actionsInContextDialogResources: actionsInContextDialogResources,
                documentActionsMenuResources: documentActionsMenuResources,
                documentActionsToastResources: documentActionsToastResources,
            });
        }
        return inMemoryActionManager;
    };
})();
//# sourceMappingURL=actionManager.js.map